"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M11 8.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0zm3 0a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M15 4.5V5h4.5a.5.5 0 0 1 0 1H18v12.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 6 18.5V6H4.5a.5.5 0 0 1 0-1H9v-.5A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5m-5 0V5h4v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M17 6H7v12.5A1.5 1.5 0 0 0 8.5 20h7a1.5 1.5 0 0 0 1.5-1.5z"
  })]
}), 'Trashcan');
//# sourceMappingURL=index.js.map